var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoRanking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.60999 3.71008L3.70001 7.70007H1.23999L2.21997 3.40009C2.28997 2.98009 2.66002 2.68005 3.08002 2.68005H3.54999C4.09999 2.68005 4.70999 3.17008 4.60999 3.71008Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67993 1.03003L7.11993 7.70001H4.65991L6.26996 0.720032C6.33996 0.300032 6.70994 0 7.12994 0H7.80994C8.35994 0 8.76992 0.490029 8.66992 1.03003H8.67993Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.95 1.84009L10.6299 7.70007H8.16992L9.54993 1.5401C9.61993 1.1201 9.98991 0.820068 10.4099 0.820068H11.0899C11.6399 0.820068 12.05 1.3101 11.95 1.8501V1.84009Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0100098 10.5L0.179993 9.72998C0.249993 9.30998 0.619978 9 1.03998 9H11.88L11.75 9.77002C11.68 10.19 11.31 10.5 10.88 10.5H0H0.0100098Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRanking);
export default __webpack_public_path__ + "static/media/ico_ranking.303225aca5380bd3ce8b3dd3d52c2bcd.svg";
export { ForwardRef as ReactComponent };